import { FC } from 'react';

import { PageWrapper } from '../../components';
import { useRoutesWithBreadcrumbs } from '../../context';
import { Profile } from './pages';

const routes = [
  {
    label: 'My Profile',
    path: '/',
    element: <Profile />,
    index: true,
  },

];

export const UserProfileEntrypoint: FC = () => {
  const page = useRoutesWithBreadcrumbs(routes);
  return (
    <PageWrapper key="tab-view">
      {page}
    </PageWrapper>
  );
};
